<div class="game-period-filters">
	<mtg-dropdown
		[formControl]="periodControl"
		variant="button"
		label="Период"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let period of periods"
			[value]="period"
		>{{ period }} период</mtg-dropdown-item>
		<mtg-dropdown-item
			*ngFor="let p of overtimePeriods"
			[value]="p"
		>
			<ng-container *ngIf="p === game.hockeyGameConfig.overtimePeriod">Овертайм</ng-container>
			<ng-container *ngIf="p === game.hockeyGameConfig.bullitsPeriod">Буллиты</ng-container>
			<ng-container *ngIf="p === game.hockeyGameConfig.playoffBullitsPeriod">Буллиты на победителя серии</ng-container>
		</mtg-dropdown-item>
	</mtg-dropdown>
	<mtg-dropdown
		[formControl]="positionControl"
		label="Позиция"
		variant="button"
		[errorVisible]="false"
	>
		<mtg-dropdown-item
			*ngFor="let value of positions"
			[value]="value"
		>{{ value | localization: positionLocalization }}</mtg-dropdown-item>
	</mtg-dropdown>
	<div class="search">
		<mtg-text-field
			size="sm"
			placeholder="Искать игрока..."
			[formControl]="query"
			trailingIcon="icons-search"
			[errorVisible]="false"
		></mtg-text-field>
	</div>
</div>

<mtg-table [stickyTop]="headerHeight" [showScrollArrows]="true">
	<mtg-table-header-row mtgSticky="top" [top]="headerHeight">
		<mtg-table-identity-col>
			<div class="team">
				<div class="logo">
					<a [routerLink]="getTeamRoute(team.id)" [queryParams]="{season_id: game.tournament.seasonId}">
						<img [src]="team.logo.path" *ngIf="team.logo.path" [alt]="team.name"/>
						<div [class]="team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
					</a>
				</div>
				<div class="name">
					<a [routerLink]="getTeamRoute(team.id)" [queryParams]="queryParams">{{ team.name }}</a>
				</div>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col-group title="Очки">
			<mtg-table-col>Голы</mtg-table-col>
			<mtg-table-col>Передачи</mtg-table-col>
			<mtg-table-col>Всего</mtg-table-col>
			<mtg-table-col>процент реализации</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Броски">
			<mtg-table-col>в створ</mtg-table-col>
			<mtg-table-col>всего</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group title="Доп. статистика">
			<mtg-table-col>Штрафные минуты</mtg-table-col>
			<mtg-table-col>Голы в большинстве</mtg-table-col>
			<mtg-table-col>Голы в меньшинстве</mtg-table-col>
			<mtg-table-col>Блок. броски</mtg-table-col>
			<mtg-table-col>% выигр. вбрасыв.</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-header-row>
	<mtg-table-row>
		<mtg-table-identity-col>
			<div class="total-title">
				<mtg-svg-icon icon="icons-hockey"></mtg-svg-icon>
				Всего
			</div>
		</mtg-table-identity-col>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('totalGoals') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('assists') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('points') }}</mtg-table-col>
			<mtg-table-col>{{ getPercent(getTotal('totalGoals'), getTotal('totalShots')) }}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('shotsOnGoal') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('totalShots') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getTotal('penaltyMinutes') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('ppGoals') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('shGoals') }}</mtg-table-col>
			<mtg-table-col>{{ getTotal('blockShots') }}</mtg-table-col>
			<mtg-table-col>{{ getPercent(getTotal('faceOffWins'), getTotal('faceOffs')) }}%</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-row>
	<mtg-table-row *ngFor="let user of players; trackBy: identify">
		<mtg-table-identity-col>
			<div class="number">{{ user.gameUserNumber || '–' }}</div>
			<div class="photo">
				<a [routerLink]="getUserProfileRoute(user)" [queryParams]="queryParams">
					<ng-container *ngIf="!user.tournamentTeamUser.id">
						<img [src]="user.teamUser.user.photo.path"
								 *ngIf="user.teamUser.user.photo.path"
								 class="circle-image"/>
						<div class="empty-photo" *ngIf="!user.teamUser.user.photo.path">{{ user.teamUser.user.initials }}</div>
					</ng-container>
					<ng-container *ngIf="user.tournamentTeamUser.id">
						<img [src]="user.tournamentTeamUser.leaguePlayer.photo.path"
								 *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path"
								 class="circle-image"/>
						<div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
					</ng-container>
				</a>
			</div>
			<div class="info">
				<a [routerLink]="getUserProfileRoute(user)" [queryParams]="queryParams">
					<ng-container *ngIf="user.tournamentTeamUser.id">
						<div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
					</ng-container>
					<ng-container *ngIf="!user.tournamentTeamUser.id">
						<div class="name">{{ user.teamUser.user.shortName }}</div>
					</ng-container>
					<div class="rating" *ngIf="user.tournamentTeamUser.leaguePlayer.rating">
						Индекс: {{ user.tournamentTeamUser.leaguePlayer.rating }}
					</div>
					<div class="text-muted">{{ user.teamUser.user.hockeyProfile.position | localization: positionLocalization }}</div>
				</a>
			</div>
		</mtg-table-identity-col>
		<mtg-table-col-group>
			<mtg-table-col>{{ getUserStatistic(user.id, 'totalGoals') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'assists') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'points') }}</mtg-table-col>
			<mtg-table-col>{{ getPercent(getUserStatistic(user.id,'totalGoals'), getUserStatistic(user.id,'totalShots'))}}%</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getUserStatistic(user.id, 'shotsOnGoal') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'totalShots') }}</mtg-table-col>
		</mtg-table-col-group>
		<mtg-table-col-group>
			<mtg-table-col>{{ getUserStatistic(user.id, 'penaltyMinutes') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'ppGoals') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'shGoals') }}</mtg-table-col>
			<mtg-table-col>{{ getUserStatistic(user.id, 'blockShots') }}</mtg-table-col>
			<mtg-table-col>{{ getPercent(getUserStatistic(user.id, 'faceOffWins'), getUserStatistic(user.id,'faceOffs')) }}%</mtg-table-col>
		</mtg-table-col-group>
	</mtg-table-row>
</mtg-table>

<mtg-table [stickyTop]="headerHeight" [showScrollArrows]="true">
    <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
        <mtg-table-identity-col>
            <div class="team">
                <div class="name">
                    Вратари
                </div>
            </div>
        </mtg-table-identity-col>
        <mtg-table-col-group title="Шайбы пропущено">
          <mtg-table-col>в меньшинстве</mtg-table-col>
          <mtg-table-col>всего</mtg-table-col>
        </mtg-table-col-group>
        <mtg-table-col-group title="Сейвы">
          <mtg-table-col>в меньшинстве</mtg-table-col>
          <mtg-table-col>всего / Все броски</mtg-table-col>
          <mtg-table-col>% сейвов</mtg-table-col>
        </mtg-table-col-group>
        <mtg-table-col-group title="Буллиты">
          <mtg-table-col>отраженные</mtg-table-col>
          <mtg-table-col>пропущенные</mtg-table-col>
          <mtg-table-col>% отражения</mtg-table-col>
        </mtg-table-col-group>
        <mtg-table-col>Мин.</mtg-table-col>
        <mtg-table-col>+/-</mtg-table-col>
    </mtg-table-header-row>
    <mtg-table-row *ngFor="let user of goalkeepers; trackBy: identify">
        <mtg-table-identity-col>
            <div class="number">{{ user.gameUserNumber || '–' }}</div>
            <div class="photo">
                <a [routerLink]="getUserProfileRoute(user)" [queryParams]="queryParams">
                    <ng-container *ngIf="!user.tournamentTeamUser.id">
                        <img [src]="user.teamUser.user.photo.path"
                             *ngIf="user.teamUser.user.photo.path"
                             class="circle-image"/>
                        <div class="empty-photo" *ngIf="!user.teamUser.user.photo.path">{{ user.teamUser.user.initials }}</div>
                    </ng-container>
                    <ng-container *ngIf="user.tournamentTeamUser.id">
                        <img [src]="user.tournamentTeamUser.leaguePlayer.photo.path"
                             *ngIf="user.tournamentTeamUser.leaguePlayer.photo.path"
                             class="circle-image"/>
                        <div class="empty-photo" *ngIf="!user.tournamentTeamUser.leaguePlayer.photo.path">{{ user.tournamentTeamUser.leaguePlayer.initials }}</div>
                    </ng-container>
                </a>
            </div>
            <div class="info">
                <a [routerLink]="getUserProfileRoute(user)" [queryParams]="queryParams">
                    <ng-container *ngIf="user.tournamentTeamUser.id">
                        <div class="name">{{ user.tournamentTeamUser.leaguePlayer.shortName }}</div>
                    </ng-container>
                    <ng-container *ngIf="!user.tournamentTeamUser.id">
                        <div class="name">{{ user.teamUser.user.shortName }}</div>
                    </ng-container>
                    <div class="text-muted">{{ user.teamUser.user.hockeyProfile.position | localization: positionLocalization }}</div>
                </a>
            </div>
        </mtg-table-identity-col>
        <mtg-table-col-group>
          <mtg-table-col>{{ getUserStatistic(user.id, 'shGoalsAgainst') }}</mtg-table-col>
          <mtg-table-col>{{ getUserStatistic(user.id, 'totalGoalsAgainst') }}</mtg-table-col>
        </mtg-table-col-group>
        <mtg-table-col-group>
          <mtg-table-col>{{ getUserStatistic(user.id, 'shSaves') }}</mtg-table-col>
          <mtg-table-col>{{ getUserStatistic(user.id, 'totalSaves') }} / {{ getUserStatistic(user.id, 'totalShotsAgainst') }}</mtg-table-col>
          <mtg-table-col>{{ getUserStatistic(user.id, 'totalSavesPercent') }}</mtg-table-col>
        </mtg-table-col-group>
        <mtg-table-col-group>
          <mtg-table-col>{{ getUserStatistic(user.id, 'shootoutSaves') }}</mtg-table-col>
          <mtg-table-col>{{ getUserStatistic(user.id, 'shootoutGoalsAgainst') }}</mtg-table-col>
          <mtg-table-col>{{ getUserStatistic(user.id, 'shootoutSavesPercent') }}</mtg-table-col>
        </mtg-table-col-group>
        <mtg-table-col>{{ userMinutes[user.id] || 0 }}</mtg-table-col>
        <mtg-table-col>{{ userEfficiency[user.id] || 0 }}</mtg-table-col>
    </mtg-table-row>
</mtg-table>

